import { render, staticRenderFns } from "./KanbanTaskLaneInfiniteScroll.vue?vue&type=template&id=23ddb1e2&scoped=true"
import script from "./KanbanTaskLaneInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./KanbanTaskLaneInfiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./KanbanTaskLaneInfiniteScroll.vue?vue&type=style&index=0&id=23ddb1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddb1e2",
  null
  
)

export default component.exports